import _ from 'underscore';
import React, { useRef, useState } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
	handleEnterKey,
	handleParentBlur,
	handleParentFocus
} from 'utils/helpers/accessible-events';
import { urlWithoutBasePath } from 'utils/helpers/links';

import NavigationItem from './components/Item';

import styles from './styles.module.scss';

const Navigation = ({
	primacy,
	data,
	theme,
	color,
	router,
	rubricPath,
	parentTabIndex
}) => {
	const [tabIndex, setTabIndex] = useState(parentTabIndex);
	const firstItemRef = useRef();
	const allowListARIA = data.length > 1;

	const navigationCx = cx(
		styles[primacy],
		styles[`theme_${theme}`],
		styles[`color_${color}`]
	);

	const handleKeyDown = (event) =>
		handleEnterKey(event, () => {
			event.preventDefault();
			setTabIndex(0);
			firstItemRef?.current?.focus();
		});

	const handleBlur = (event) =>
		handleParentBlur(event, () => {
			if (allowListARIA) {
				setTabIndex(-1);
			}
		});

	const handleFocus = (event) =>
		handleParentFocus(event, () => {
			setTabIndex(-1);
		});

	return (
		<nav className={navigationCx}>
			<ul
				aria-label="Меню"
				className={styles.list}
				onBlur={handleBlur}
				onFocus={handleFocus}
				onKeyDown={handleKeyDown}
				role="menubar"
				tabIndex={parentTabIndex}
			>
				{_(data).map((item, index) => {
					const url = urlWithoutBasePath(item.url);
					const path = rubricPath ? `/${rubricPath}` : router.asPath;
					const active = path.startsWith(item.url);

					return (
						<NavigationItem
							itemRef={index === 0 ? firstItemRef : null}
							primacy={primacy}
							active={active}
							item={{ ...item, ...active, url }}
							key={item.url}
							tabIndex={tabIndex}
							totalItems={data.length}
							indexNumber={index}
						/>
					);
				})}
			</ul>
		</nav>
	);
};

Navigation.propTypes = {
	primacy: PropTypes.string.isRequired,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
			active: PropTypes.bool,
			target: PropTypes.string
		})
	),
	theme: PropTypes.string,
	color: PropTypes.string,
	rubricPath: PropTypes.string,
	router: PropTypes.object.isRequired,
	parentTabIndex: PropTypes.number
};

Navigation.defaultProps = {
	data: [
		{
			active: null,
			target: null
		}
	]
};

export default withRouter(Navigation);
